export default {
  methods: {
    toggleQuestion(componentName, title) {
      console.log(componentName, title)
      return new Promise((res, rej) => {
        const pr = arg => {
          console.log(arg)
          return new Promise((resolve, reject) => {
            if (arg) {
              resolve(arg)
            } else {
              reject()
            }
          }).then(result => {
            res(result)
          }, err => {
            rej(err)
          })
        }
        const data = {
          question: title,
          promise: pr,
        }
        this.toggleModalMixin(componentName, data)
      })
    },
    toggleModalMixin(componentName, data, classList) {
      this.$emit('close')
      this.$modal.show(() => import('../components/Modals/SampleModal'), {
        component: componentName,
        objectItem: data,
      }, {
        classes: `cabinet-modal cabinet-modal--container cabinet-modal--size_sm ${classList}`,
      })
    },
    toggleToster(message) {
      this.$emit('close')
      this.$toasted.show(message)
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/mixins/ToggleModalMixin.js